import { documentationActions } from '../../actions/constant';

const { GET_DASHBOARD_DOCUMENT_DATA, RESET_DASHBOARD_DOCUMENT_DATA } = documentationActions;

const initialState: object = {
  document: null,
};

export const dashboardCreateEditDocumentDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_DOCUMENT_DATA: {
      return {
        document: action.payload,
      };
    }

    case RESET_DASHBOARD_DOCUMENT_DATA:
      return initialState;

    default:
      return state;
  }
};
